var _path, _path2, _g, _g2, _circle, _ellipse, _path3, _path4, _path5, _path6, _path7, _ellipse2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g3, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmittedimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 215,
    viewBox: "0 0 248 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.723 208.641C252.448 196.886 234.741 138.792 117.9 140.505C33.5645 141.742 -4.44304 190.063 4.46936 214.138",
    fill: "url(#paint0_radial_8430_201178)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8430_201178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 140,
    width: 245,
    height: 75
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.723 208.641C252.448 196.886 234.741 138.792 117.9 140.505C33.5645 141.742 -4.44304 190.063 4.46936 214.138",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8430_201178)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.671968,
    cx: 100.358,
    cy: 173.486,
    rx: 6.42639,
    ry: 3.56955,
    transform: "rotate(-0.840131 100.358 173.486)",
    fill: "url(#paint1_linear_8430_201178)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 165.863,
    cy: 167.076,
    rx: 10.1394,
    ry: 5.56849,
    transform: "rotate(-0.840131 165.863 167.076)",
    fill: "url(#paint2_linear_8430_201178)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.729957,
    cx: 50.2688,
    cy: 153.92,
    rx: 10.1394,
    ry: 5.56849,
    transform: "rotate(-0.840131 50.2688 153.92)",
    fill: "url(#paint3_linear_8430_201178)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.320685
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.436,
    cy: 42.1085,
    rx: 6.85482,
    ry: 6.85353,
    transform: "rotate(-0.840131 190.436 42.1085)",
    fill: "url(#paint4_linear_8430_201178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.736 46.1995C194.782 46.1379 192.22 45.6106 189.589 44.6967C186.958 43.7829 184.621 42.6081 183.05 41.4452C182.387 40.9541 181.901 40.4933 181.626 40.117C181.705 40.0953 181.794 40.0745 181.893 40.0556C182.645 39.912 183.745 39.9145 185.058 40.08L185.487 36.6795C181.682 36.1999 178.935 36.7246 178.173 38.9172C177.065 42.1064 181.82 45.6261 188.464 47.9343C195.109 50.2426 201.023 50.429 202.131 47.24C202.908 45.0035 201.109 43.272 197.308 40.996L195.547 43.9365C196.84 44.7106 197.807 45.3972 198.397 45.9655C198.439 46.0051 198.477 46.0436 198.513 46.0806C198.072 46.1778 197.466 46.2225 196.736 46.1995Z",
    fill: "url(#paint5_linear_8430_201178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.303 42.0079C197.248 38.2232 194.134 35.2001 190.349 35.2556C186.563 35.3111 184.228 37.7656 183.779 40.5012C183.779 40.5012 187.755 42.91 189.582 43.4135C190.165 43.574 190.743 43.785 191.332 43.9708C191.99 44.1787 192.66 44.3608 193.337 44.5173C193.801 44.6244 194.437 44.7912 195.03 44.8924C195.812 45.026 196.511 45.0805 196.566 45.0797C196.663 45.0782 196.762 44.6458 196.973 44.1405C197.184 43.6352 197.303 42.0079 197.303 42.0079Z",
    fill: "url(#paint6_linear_8430_201178)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.418364,
    cx: 40.4374,
    cy: 84.7437,
    r: 7.9929,
    transform: "rotate(-0.840131 40.4374 84.7437)",
    fill: "url(#paint7_linear_8430_201178)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.425921,
    cx: 127.94,
    cy: 151.643,
    rx: 23.9787,
    ry: 6.58239,
    transform: "rotate(-0.840131 127.94 151.643)",
    fill: "url(#paint8_linear_8430_201178)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.837 114.276C110.837 114.276 110.208 116.187 110.227 117.524C109.742 129.171 111.647 148.12 111.647 148.12L114.175 148.083L117.487 119.48L122.963 147.955L125.449 147.918C125.449 147.918 125.509 129.586 124.344 117.317C124.324 115.994 123.733 114.734 123.733 114.734L110.837 114.276Z",
    fill: "url(#paint9_linear_8430_201178)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.394 99.5781L103.401 100.837L101.684 100.408L90.7987 98.9899L88.1757 99.0284L88.1145 95.5563L88.7811 96.8799L89.9508 97.2286C89.9508 97.2286 90.5598 95.9518 90.7572 96.1652C90.9547 96.3786 91.052 97.268 91.052 97.268L92.0299 97.7561L103.594 97.5865L106.303 95.9411L108.394 99.5781Z",
    fill: "#FDE7E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.694 99.3396L129.872 100.45L131.575 99.9701L142.415 98.2335L145.364 96.6747L146.344 94.643L145.966 94.595L144.369 96.0652L143.21 96.4481C143.21 96.4481 142.564 95.1897 142.373 95.4088C142.182 95.6278 142.111 96.5197 142.111 96.5197L141.148 97.0363L129.583 97.2059L126.677 95.6428L124.694 99.3396Z",
    fill: "#FDE7E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.59 95.8422L126.056 99.7372L122.168 99.7942L124.121 115.85C124.121 115.85 119.23 116.746 116.641 116.984C114.051 117.222 110.345 116.053 110.345 116.053C110.345 116.053 110.262 110.445 110.115 100.381L106.657 100.022L105.964 96.1593C105.964 96.1593 109.155 93.8487 110.013 93.4598C110.872 93.0709 113.786 92.6026 113.786 92.6026L118.405 92.5348C118.405 92.5348 122.077 92.6228 122.78 93.2726C123.484 93.9223 127.59 95.8422 127.59 95.8422Z",
    fill: "url(#paint10_linear_8430_201178)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.048 89.7186L115.155 89.761L115.212 93.6003L118.105 93.5579L118.048 89.7186ZM116.402 95.7811C116.394 95.236 115.213 93.6008 115.213 93.6008L118.106 93.5584C118.106 93.5584 116.41 96.3262 116.402 95.7811Z",
    fill: "#FECECD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.447,
    cy: 88.5724,
    rx: 3.04535,
    ry: 4.31623,
    transform: "rotate(-0.840131 116.447 88.5724)",
    fill: "#FFE9E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.11 88.9017C113.342 88.0844 113.315 86.2898 113.802 86.2241C114.288 86.1584 115.267 86.4839 116.232 85.8104C116.714 85.4414 116.957 85.3925 116.954 85.2107C119.397 85.608 117.959 86.9362 119.193 88.3581C119.322 88.5064 119.68 88.351 119.68 88.351C119.68 88.351 119.628 84.8063 119.38 84.4936C119.132 84.1809 118.139 82.9217 117.665 83.8373C117.658 83.383 116.677 82.9287 115.708 83.2908C114.738 83.653 113.287 84.3558 113.057 85.2678C112.826 86.1799 112.609 88.0004 113.11 88.9017Z",
    fill: "#513450"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.841 148.117L111.182 149.278C110.749 150.039 110.528 150.903 110.541 151.778C110.542 151.844 110.596 151.897 110.662 151.896L113.806 151.85C114.081 151.846 114.3 151.62 114.296 151.345C114.283 150.431 114.101 149.527 113.761 148.678L113.527 148.092L111.841 148.117Z",
    fill: "#677285"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M125.119 147.922L125.812 149.064C126.267 149.812 126.513 150.668 126.526 151.544C126.527 151.61 126.474 151.664 126.408 151.665L123.264 151.711C122.99 151.715 122.764 151.496 122.76 151.221C122.746 150.307 122.901 149.398 123.216 148.54L123.433 147.947L125.119 147.922Z",
    fill: "#677285"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8301 7.21704L89.6508 7.17568L91.7534 150.562C91.7649 151.341 91.1427 151.982 90.3638 151.993C89.5848 152.005 88.9441 151.383 88.9327 150.604L86.8301 7.21704Z",
    fill: "#D8D8D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7923 7.302L104.16 11.1648C110.558 12.5877 117.259 11.4027 122.78 7.87198C130.571 2.89046 140.17 1.62327 148.987 4.41259L154.96 6.30239L150.774 41.5482L149.443 41.0276C140.879 37.6789 131.178 39.17 124.014 44.936C118.282 49.5504 110.498 50.6948 103.68 47.9258L87.2904 41.2695L86.7923 7.302Z",
    fill: "#8ED28E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M128.649 14.9388C129.572 13.8611 131.186 13.7527 132.244 14.6975C133.291 15.632 133.399 17.2459 132.486 18.312L117.252 36.1095C116.804 36.6327 116.176 36.9437 115.506 36.9887C114.835 37.0337 114.171 36.8095 113.657 36.3509L104.464 28.1433C103.417 27.2088 103.309 25.5949 104.221 24.5289C105.144 23.4512 106.758 23.3429 107.816 24.2876L115.089 30.7807L128.649 14.9388Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8430_201178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 14,
    width: 31,
    height: 23
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.649 14.9388C129.572 13.8611 131.186 13.7527 132.244 14.6975C133.291 15.632 133.399 17.2459 132.486 18.312L117.252 36.1095C116.804 36.6327 116.176 36.9437 115.506 36.9887C114.835 37.0337 114.171 36.8095 113.657 36.3509L104.464 28.1433C103.417 27.2088 103.309 25.5949 104.221 24.5289C105.144 23.4512 106.758 23.3429 107.816 24.2876L115.089 30.7807L128.649 14.9388Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8430_201178)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M115.203 30.63L109.279 37.1536L102.631 32.8875L111.885 23.3131L115.203 30.63Z",
    fill: "url(#paint11_linear_8430_201178)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5322 96.3375C87.5322 96.3375 88.9322 95.6116 88.9356 95.8467C88.9391 96.0817 88.977 98.6674 88.977 98.6674L88.0437 99.1513L87.5322 96.3375Z",
    fill: "#FFE9E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8430_201178",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.641 165.6) rotate(-90.8401) scale(41.8404 436.981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEDF0",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536775,
    stopColor: "#EBEDF0",
    stopOpacity: 0.845525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E4E7",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8430_201178",
    x1: 95.1852,
    y1: 172.54,
    x2: 97.1431,
    y2: 176.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8430_201178",
    x1: 157.349,
    y1: 166.555,
    x2: 160.931,
    y2: 174.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8430_201178",
    x1: 43.8037,
    y1: 154.01,
    x2: 45.8308,
    y2: 162.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8430_201178",
    x1: 181.072,
    y1: 37.3892,
    x2: 184.499,
    y2: 49.2388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717538,
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCC3CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8430_201178",
    x1: 184.018,
    y1: 44.8824,
    x2: 200.91,
    y2: 50.7518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAC6D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8430_201178",
    x1: 187.906,
    y1: 41.5558,
    x2: 190.214,
    y2: 46.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D6DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8430_201178",
    x1: 50.9453,
    y1: 87.1161,
    x2: 42.9641,
    y2: 73.6372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE2E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E3EBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF6F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8430_201178",
    x1: 109.941,
    y1: 152.423,
    x2: 123.409,
    y2: 173.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CFD3",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8430_201178",
    x1: 125.475,
    y1: 147.918,
    x2: 124.982,
    y2: 114.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1A7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B8195"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8430_201178",
    x1: 138.643,
    y1: 103.402,
    x2: 118.18,
    y2: 127.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E9F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2DAE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8430_201178",
    x1: 105.61,
    y1: 30.4574,
    x2: 111.76,
    y2: 34.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67D666",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67D666",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedimg);
export default __webpack_public_path__ + "static/media/submittedimg.8ebdb534b0698a1185febfe758965a76.svg";
export { ForwardRef as ReactComponent };